import { Box, Center, Text } from "@mantine/core";
import { useEffect, useState, useRef } from "react";
import "./Intro.css";
import BussinesName from "./components/BussinesName.jsx";
import { logAnalyticsEvent } from "../../services/firebase.js";

const Intro = () => {
    const step0 = useRef(null);
    const step1 = useRef(null);
    const [step, setStep] = useState(0);

    // Utility function to handle timeouts with async/await
    const wait = (time) => new Promise(resolve => setTimeout(resolve, time));

    useEffect(() => {
        const animateSteps = async () => {
            await wait(3000);
            step0.current.classList.add("disappear");
            await wait(1000);
            setStep(1);
            await wait(1500);
            step1.current.classList.add("disappear");
            await wait(1000);
            setStep(2);
        };

        if (step === 0) {
            animateSteps();
        }

        logAnalyticsEvent("tutorial_begin")

        return () => clearTimeout(); // Cleanup timeouts if component unmounts
    }, []);

    return (
        <Center h="100vh">
            {step === 0 && (
                <Text ref={step0}>
                    <h1>Bienvenido</h1>
                    <br />
                    <h2 className="reveal">a Emme negocios</h2>
                </Text>
            )}
            {step === 1 && (
                <Box ref={step1} className="reveal">
                    <h2 className="reveal">¡Vamos a comenzar!</h2>
                </Box>
            )}
            {step === 2 && (
                <BussinesName setStep={setStep} wait={wait} />
            )}

        </Center>
    );
};

export default Intro;
